import tw, { css, styled } from 'twin.macro';
import SVGIcon from '../SVGIcon/SVGIcon';

export const StyledMessageBar = styled.div(({ $variant, $size }) => [
  tw`border-l-4 border-solid pl-12`,
  $size === 'default' && tw`pr-16 py-8`,
  $size === 'small' && tw`pr-16 py-4 pl-8`,
  $variant === 'warning' && tw`bg-orange-lighten-40 border-orange-base`,
  $variant === 'error' && tw`bg-red-lighten-40 border-red-darken-10`,
  $variant === 'success' && tw`bg-green-lighten-40 border-green-darken-10`,
  $variant === 'info' && tw`bg-blue-lighten-40 border-blue-darken-10`
]);

export const StyledMessageBarHeader = styled.div(({ $size }) => [
  tw`flex items-center `,
  $size === 'default' && tw`mb-8`,
  $size === 'small' && tw`mb-4`
]);

export const StyledMessageBarIcon = styled(SVGIcon).attrs(({ $iconSize }) => ({
  size: $iconSize
}))(({ $variant, $messageBarSize, $inlineWithText }) => [
  tw`mr-4 `,
  $inlineWithText && tw`inline-block`,
  $inlineWithText &&
    $messageBarSize === 'default' &&
    css`
      margin-top: -0.375rem;
    `,
  $inlineWithText && $messageBarSize === 'small' && tw`-mt-4`,

  $variant === 'warning' && tw` fill-orange-base`,
  $variant === 'error' && tw` fill-red-darken-10`,
  $variant === 'success' && tw` fill-green-darken-10`,
  $variant === 'info' && tw` fill-blue-darken-10`
]);
